import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 30, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className = "", lineClassName = "", baseDelay = 0.15 }) => {
  const container = {
    hidden: {},
    visible: {
      transition: { staggerChildren: 0.12, delayChildren: baseDelay },
    },
  };
  const child = {
    hidden: { y: "100%" },
    visible: {
      y: 0,
      transition: { duration: 1, ease: [0.16, 1, 0.3, 1] },
    },
  };
  return (
    <motion.span className={className} variants={container} initial="hidden" animate="visible">
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
          <motion.span className={`block ${lineClassName}`} variants={child}>
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};
